import './App.css';
import React from 'react';
import RouterConfig from './RouterConfig.js';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: '',
});

function App() {
  return <RouterConfig />;
}

export default App;
